/**
 * BrandMarquee — infinite scrolling brand strip.
 * Pure CSS, no JS, GPU-accelerated.
 */
export default function BrandMarquee({
  items = [],
  speed = 'normal',   // 'slow' | 'normal' | 'fast'
  direction = 'left', // 'left' | 'right'
  className = '',
  glow = true,
}) {
  const duration = speed === 'slow' ? '50s' : speed === 'fast' ? '18s' : '28s';
  const animationDir = direction === 'right' ? 'reverse' : 'normal';
  return (
    <div className={`relative overflow-hidden ${className}`} aria-label="Brand logos">
      {/* Edge fade masks */}
      <div className="absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#0A0A0F] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#0A0A0F] to-transparent pointer-events-none" />

      <div
        className="marquee-track flex items-center gap-12 whitespace-nowrap py-4"
        style={{ animationDuration: duration, animationDirection: animationDir }}
      >
        {items.map((item, i) => (
          <div
            key={`a-${i}`}
            className={`flex items-center gap-2 text-2xl md:text-3xl font-black tracking-[-0.02em] uppercase shrink-0 ${glow ? 'text-white/85' : 'text-white/55'}`}
            style={glow ? { textShadow: '0 0 20px rgba(255, 107, 74, 0.25)' } : undefined}
          >
            <span aria-hidden className="w-1.5 h-1.5 rounded-full bg-[#FF6B4A]" />
            {item}
          </div>
        ))}
        {/* Duplicate half — aria-hidden so screen readers don't announce twice */}
        {items.map((item, i) => (
          <div
            key={`b-${i}`}
            aria-hidden
            className={`flex items-center gap-2 text-2xl md:text-3xl font-black tracking-[-0.02em] uppercase shrink-0 ${glow ? 'text-white/85' : 'text-white/55'}`}
            style={glow ? { textShadow: '0 0 20px rgba(255, 107, 74, 0.25)' } : undefined}
          >
            <span aria-hidden className="w-1.5 h-1.5 rounded-full bg-[#FF6B4A]" />
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
